import API from './resources'

const actions = {
  async requestUrl ({ commit }, payload) {
    let data, token
    [ data, token ] = payload
    try {
      const response = await API.shortUrl(data, token)
      commit('SET_URL', response)
      return response
    } catch (error) {
      return error
    }
  },
  async getUrlLongEdit({ commit, state }, payload) {
    try {
      const response = await API.getUrl(
        state.url,
        payload.token
        )
      commit('SET_URL', response.data)
      return response.data
    } catch (error) {
      return error
    }
  },
  async getHistoryUrlShort({ commit }, payload) {
    try {
      const response = await API.getHistory(
        payload.shortUrl,
        payload.token
        )
      commit('SET_HISTORY_URL', response.data)
      return response.data
    } catch (error) {
      return error
    }
  },
  async getUrlShort({ commit, state }, payload) {
    try {
      const response = await API.getUrl(
        state.url,
        payload.token
        )
      commit('SET_URL', response.data)
      return response.data
    } catch (error) {
      return error
    }
  },
  async getUrlLongReport({ commit, state }, payload) {
    try {
      const response = await API.getUrlLong(
        state.url,
        payload.token
        )
      commit('SET_URL', response.data)
      return response.data
    } catch (error) {
      return error
    }
  },
  async updateUrlEdit ({commit}, payload) {
    let data, token
    [ data, token ] = payload
    try {
      const response = await API.updateUrl(
        data,
        token
      )
      commit('SET_URL_UPDATE', response)
      return response
    } catch (error) {
      return error
    }
  },
  async customNewtUrl ({ commit }, payload) {
    let data, token
    [ data, token ] = payload
    try {
      const response = await API.customUrl(data, token)
      commit('SET_URL', response)
      return response
    } catch (error) {
      return error
    }
  },
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/urltools/actions.js